// Reactive mirror of `window.history` state.
//
// Three runes track the URL — pathname / search / hash. Components
// reading them automatically re-render on navigation. The runes are
// kept in sync by:
//
//   1. The `popstate` listener wired up at module load (browser back/
//      forward button).
//   2. `navigate.ts`'s `push()` / `replace()` calling `sync()` after
//      mutating `window.history`.
//
// `.svelte.ts` extension is the marker that tells the Svelte compiler
// to treat the runes as reactive even though this isn't a component.

class HistoryStore {
  pathname = $state<string>("/");
  search = $state<string>("");
  hash = $state<string>("");

  query = $derived<URLSearchParams>(new URLSearchParams(this.search));

  constructor() {
    if (typeof window === "undefined") return;
    this.sync();
    window.addEventListener("popstate", () => this.sync());
  }

  /** Re-read `window.location` into the runes. Called by navigate.ts
   *  after `pushState`/`replaceState`, and by the popstate listener. */
  sync(): void {
    this.pathname = window.location.pathname;
    this.search = window.location.search;
    this.hash = window.location.hash;
  }
}

export const history = new HistoryStore();
